import { render, staticRenderFns } from "./view-school.vue?vue&type=template&id=555e75b9"
import script from "./view-school.vue?vue&type=script&lang=js"
export * from "./view-school.vue?vue&type=script&lang=js"
import style0 from "./view-school.vue?vue&type=style&index=0&id=555e75b9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports